<app-page-wrapper>
  <app-loading-spinner *ngIf="!student || !courses;else main_content"></app-loading-spinner>
  <ng-template #main_content>

    <div class="my-4">
      <a *ngIf="classSectionId && classId && !isParent" routerLink="/classes/{{ classSectionId }}/class/{{ classId }}"
        class="breadcrumb-link">
        <i class="far fa-angle-left"></i>
        {{ className }}
      </a>
    </div>

    <div class="d-flex align-items-center my-4 header">
      <app-profile-picture class="mr-3 large" [name]="student.Name"></app-profile-picture>
      <div class="d-flex align-items-end">
        <h1 class="m-0 mr-2">{{ editObj === student ? 'Edit Student' : student.Name }}</h1>
        <span *ngIf="editObj !== student && student.ExternalID">#{{ student.ExternalID }}</span>
      </div>

      <div class="ml-auto d-flex align-items-center">
        <app-passcode [passcode]="student.PassCode" [size]="miniSize"
          *ngIf="student.PassCode && !resettingPasscode && !editObj && !deleteObj"></app-passcode>
        <app-student-qr-modal [StudentID]="student.ID"></app-student-qr-modal>
        <span (click)="startEditObj($event, student)" *ngIf="!editObj && !deleteObj && !isParent" class="ml-4 no-print"
          ngbTooltip="Edit">
          <i class="fal fa-pencil-alt pointer"></i>
        </span>
        <span (click)="deleteStudent()" *ngIf="!editObj && !deleteObj && !isParent" class="ml-4 no-print"
          ngbTooltip="Delete">
          <i class="fal fa-trash-alt pointer"></i>
        </span>
        <span (click)="printPage()" *ngIf="!editObj && !deleteObj" class="no-print ml-4" ngbTooltip="Print">
          <i class="fal fa-print pointer"></i>
        </span>
        <span class="no-print ml-4" (click)="updateStudent()" *ngIf="!saving && editObj === student" ngbTooltip="Save">
          <i class="fal fa-save pointer"></i>
        </span>
        <span (click)="cancelEditObj($event, student)" *ngIf="!saving && editObj === student" class="ml-4 no-print"
          ngbTooltip="Cancel">
          <i class="fal fa-times pointer"></i>
        </span>
        <span class="no-print" *ngIf="deleteObj === student || (saving && editObj === student)">
          <i class="fal fa-spinner fa-spin"></i>
        </span>
      </div>
    </div>

    <div class="row header my-4" *ngIf="editObj !== student">
      <div class="col-3" *ngIf="student.ExpirationDate">
        <div class="detail-name" *ngIf="student.ExpirationDate">Expires</div>
        <div class="detail-value">{{ student.ExpirationDate | date }}</div>
      </div>
    </div>
    <div>
      <button class="btn tab-button mr-2" (click)="setPage('progress')"
        [ngClass]="pageName === 'progress' ? 'btn-selected' : 'btn-light-outlined'">
        Progress
      </button>
      <button class="btn tab-button mr-2" (click)="setPage('activity')"
        [ngClass]="pageName === 'activity' ? 'btn-selected' : 'btn-light-outlined'">
        Student Work
      </button>
      <button class="btn tab-button mr-2" (click)="setPage('parents')"
        [ngClass]="pageName === 'parents' ? 'btn-selected' : 'btn-light-outlined'">
        Parents
      </button>
      <button class="btn tab-button mr-2" (click)="setPage('certificate')"
        [ngClass]="pageName === 'certificate' ? 'btn-selected' : 'btn-light-outlined'">
        Certificates
      </button>
    </div>
    <div class="row header my-4" *ngIf="editObj === student">
      <div class="form-group col-md-6">
        <label for="student_name">Name</label>
        <input id="student_name" class="form-control" [(ngModel)]="editObj.Name" placeholder="Name"
          disabled="{{ saving }}">
      </div>
      <div class="form-group col-md-6">
        <label for="student_id">ID</label>
        <input id="student_id" class="form-control" [(ngModel)]="editObj.ExternalID" placeholder="ID"
          disabled="{{ saving }}">
      </div>
      <div class="form-group col-md-6">
        <label for="student_expires">Expires</label>
        <app-datepicker [(model)]="editObj.ExpirationDate" [disabled]="saving"></app-datepicker>
      </div>
      <div class="form-group col-md-6">
        <label for="student_passcode">Passcode string (testing only)</label>
        <input id="student_passocde" class="form-control" [(ngModel)]="editObj.PassCode" placeholder="Passcode"
          disabled="{{ saving }}">
      </div>
      <div class="form-group col-md-6">
        <label for="grade_level">Grade Level</label>
        <select class="form-control" id="gradeLevel" [(ngModel)]="editObj.GradeLevel" name="gradeLevel" placeholder="--"
          disabled="{{ saving }}">
          <option *ngFor="let gradeLevel of studentGradeLevelOptions" [value]="gradeLevel">{{ getGradeLevelString(gradeLevel) }}</option>
        </select>
      </div>
    </div>

    <div *ngIf="editObj === student">
      <h2>Passcode</h2>
      <div *ngIf="student.PassCode && !resettingPasscode">
        <app-passcode [passcode]="student.PassCode"></app-passcode>
        <button class="btn btn-light my-3" (click)="resetPasscode()">RESET</button>
      </div>
      <div *ngIf="resettingPasscode">
        <i class="fal fa-spinner fa-spin mr-2"></i>
        Resetting...
      </div>
      <div *ngIf="!student.PassCode">
        <p>No passcode set</p>
      </div>
    </div>

    <div *ngIf="pageName === 'parents'">
      <h2 class="mt-5">
        Parents
      </h2>
      <table class="table">
        <thead>
          <th>Name</th>
          <th>Email</th>
        </thead>
        <tbody>
          <tr *ngFor="let parent of student.Parents">
            <td>{{parent.Name}}</td>
            <td class="ml-1">{{parent.Email}}</td>
            <td style="text-align: right;" *ngIf="currentUserId !== parent.ID" (click)="removeParent(parent.ID)">
              <i class="fal fa-times pointer"></i>
            </td>
          </tr>
        </tbody>
      </table>
      <app-assign-student-to-parent-modal (dataRefresh)="getStudent()" [student]="student">
      </app-assign-student-to-parent-modal>
    </div>

    <div class="mt-5" *ngIf="!editObj && pageName === 'progress'">
      <app-student-progress-report [studentId]="studentId" [organizationId]="classSectionId"
        [defaultCourseCode]="getDefaultCourseCode()"></app-student-progress-report>
    </div>

    <div class="mt-5" *ngIf="!editObj && pageName === 'certificate'">
      <app-certificate-display [student]="student" [defaultCourseCode]="getDefaultCourseCode()"
        [courses]="courses"></app-certificate-display>
    </div>

    <app-recent-artifacts *ngIf="pageName === 'activity'" [defaultCourseCode]="getDefaultCourseCode()"
      [courses]="courses"></app-recent-artifacts>
  </ng-template>
</app-page-wrapper>